import { render } from "./ModalSpecialite.vue?vue&type=template&id=2a791faa"
import script from "./ModalSpecialite.vue?vue&type=script&lang=js"
export * from "./ModalSpecialite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__